module.exports = __webpack_public_path__ + "static/media/ic_dinogo_big_deal.75a588f8.png";